"use strict";

module.exports=function getTextWidth(text,font){
const canvas=getTextWidth.canvas||(getTextWidth.canvas=document.createElement("canvas"));
const context=canvas.getContext("2d");
context.font=font;

const metrics=context.measureText(text);
return Math.ceil(metrics.width);
};
//# sourceMappingURL=getTextWidth.js.map
